module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "register"
  }, [_c('app-logo'), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs12": "",
      "offset-sm2": "",
      "sm8": "",
      "offset-md3": "",
      "md6": "",
      "offset-lg4": "",
      "lg4": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n            "), _c('form', [_c('v-text-input', {
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "label": "Email"
    },
    model: {
      value: (_vm.userModel.email),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "email", $$v)
      },
      expression: "userModel.email"
    }
  }), _vm._v(" "), _c('v-text-input', {
    attrs: {
      "id": "password",
      "name": "password",
      "type": "password",
      "label": "Password"
    },
    model: {
      value: (_vm.userModel.password),
      callback: function($$v) {
        _vm.$set(_vm.userModel, "password", $$v)
      },
      expression: "userModel.password"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center text-md-center"
  }, [_c('div', {
    attrs: {
      "id": "loginBtn"
    }
  }, [_c('v-btn', {
    staticClass: "vt-submit-btn",
    attrs: {
      "ripple": {
        class: 'teal--text'
      },
      "type": "submit",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_vm._v("\n                            Login\n                        ")])], 1), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": "/register"
    }
  }, [_c('v-btn', {
    staticClass: "vt-submit-btn",
    attrs: {
      "ripple": {
        class: 'teal--text'
      },
      "round": ""
    }
  }, [_vm._v("\n                            Register\n                        ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b6a6944!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 83
// module chunks = 1